import React from 'react';
import avatar from './avatar.jpeg';

export function Bio() {
  return (
    <div className="bio">
      <div className="bio__avatar">
        <img src={avatar} alt="" />
      </div>
      <div className="bio__info">
        <section>
          Привет! Меня зовут Николай, я фронтенд-разработчик. Мне 28 лет. В
          данный момент в поисках работы.
        </section>
        <section>
          Я обладаю уверенными знаниями в HTML, CSS, SCSS, JavaScript, React.
        </section>
        <section>
          Удалось поучаствовать в командной разработке SPA-приложений с
          использованием различных npm-модулей, среди которых были такие как:
          react-hook-form, pie-chart, date-fns, cookie-js, а также Redux, Redux
          Toolkit.
        </section>
        <section>
          У меня есть базовые знания и понимания TypeScript (типы, интерфейсы,
          дженерики). Знаком с алгоритмами, метриками производительности сайта
          (Lighthouse).
        </section>
        <section>
          Изучаю Redux Saga, Next.js, Material UI, Ant Design, mobX, принципы
          SOLID.
        </section>
        <section>Уровень английского: intermediate</section>
        <section>
          Уверенный пользователь Windows, macOS. Владею слепым десятипальцевым
          методом набора на клавиатуре (RUS/EN 450/400зн/мин).
        </section>
      </div>
    </div>
  );
}
